import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import 'prismjs'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-json'
import 'prismjs/plugins/line-numbers/prism-line-numbers'
import { ToastService } from '../../services/toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import showdown from 'showdown';

declare var Prism: any

@Component({
  selector: 'app-script-view-component',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbToastModule],
  templateUrl: './script-view-component.component.html',
  styleUrl: './script-view-component.component.scss'
})
export class ScriptViewComponentComponent implements AfterViewInit {

  @ViewChild('code') code!: ElementRef;

  @Input() heading: string = ''
  @Input() message: string = ''
  @Input() size: number | undefined;
  @Input() last_modified: string | undefined;
  @Input() fileType: 'python' | 'json' | 'text' = 'text'

  public scriptMessage: string = '';

  constructor(
    private activeModal: NgbActiveModal,
    public toastService: ToastService
  ){}

  get TrimmedMessage(): string{
    return this.message.trim();
  }

  get language(): string{
    switch(this.fileType){
      case 'python':
        return 'python'
      case 'json':
        return 'json'
      default:
        return 'text'
    }
  }

  ngOnInit() {
    if (this.fileType === 'text') {
      const converter = new showdown.Converter({
        tables: true,
        emoji: true,
        ghCodeBlocks: true
      });
      this.scriptMessage = converter.makeHtml(this.TrimmedMessage);
    }
  }

  ngAfterViewInit() {
    if (this.fileType !== 'text') {
     Prism.highlightElement(this.code.nativeElement)
    }
  }

  copyToClipboard(){
    const textToCopy = this.message;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        this.toastService.showToast(`Content copied to Clipboard`, {classname: "bg-success text-light"})
      })
      .catch((err) => {
        this.toastService.showToast(`Failed to copy content: ${err}`, {classname: "bg-danger text-light"})
      })
  }

  onCancel(){
    this.activeModal.close();
  }

}
